/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { Type } from "@adapptio/lib-blueprint";
import { createSuccessNodeResult, unknownNodeError } from "../helpers";
import { NODE_OUTPUT_NAMES, TAllNodesSpec, TBlueprintLoginNodeOptsSchemaSpec } from "../../blueprints";
import { IActionContext, INodeContext, INodeResult } from "../ActionManager";

export async function loginNodeHandler<TSpec extends Partial<TAllNodesSpec>>(
	opts: TBlueprintLoginNodeOptsSchemaSpec,
	aCtx: IActionContext<TSpec>,
	nCtx: INodeContext
): Promise<INodeResult> {
	const { context } = aCtx;

	context.debug("Login node.");

	try {
		await context.session.login({ updateLastLoginAt: true });

		return createSuccessNodeResult(
			{
				opts,
				outputName: NODE_OUTPUT_NAMES.ON_SUCCESS,
				data: null,
				typeDescriptor: Type.Void({})
			},
			aCtx,
			nCtx
		);
	} catch (error) {
		return unknownNodeError(opts, error, aCtx, nCtx);
	}
}
